import { useAuth } from "@/contexts/AuthContext";
import { ROUTE } from "@/routes/constants";
import { UserInfoResponseRole } from "@/services/generatedAPIs.schemas";
import { useNavigate, Navigate } from "react-router";

export default function HomePage() {
  const token = localStorage.getItem('token');
  const { tokenLogin } = useAuth();
  const navigate = useNavigate();
  if (token) {
    tokenLogin().then((user) => {
        if (user) {
          if (user.role === UserInfoResponseRole.STUDENT) {
            navigate(ROUTE.STUDENT.OVERVIEW, { replace: true });
            // return <Navigate to={ROUTE.STUDENT.DASHBOARD} replace />;
          } else if (user.role === UserInfoResponseRole.TEACHER) {
            navigate(ROUTE.TEACHER.OVERVIEW, { replace: true });
            // return <Navigate to={ROUTE.TEACHER.DASHBOARD} replace />;
          }
        } else {
          localStorage.removeItem('token');
          navigate(ROUTE.LOGIN, { replace: true });
        }
      }).catch((error) => {
        // TODO: Handle error
        console.error("Error fetching user data:", error);
        localStorage.removeItem('token');
        navigate(ROUTE.LOGIN, { replace: true });
      });
      console.log("Loading user data...");
      return <div>Loading...</div>;
  } else {
    return <Navigate to={ROUTE.LOGIN} />;
  }
}